export default __webpack_public_path__ + "static/adam-30bda3daa6f0475a681c61aff96f4d8d.jpg";